import { forwardRef, type SVGProps } from 'react';

export const Filter = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" ref={ref} {...props}>
    <path
      d="M17.167 3.418v1.834c0 .666-.417 1.5-.834 1.916l-3.583 3.167c-.5.417-.833 1.25-.833 1.917v3.583c0 .5-.334 1.167-.75 1.417l-1.167.75c-1.083.666-2.583-.084-2.583-1.417v-4.417c0-.583-.334-1.333-.667-1.75l-.392-.408a.829.829 0 0 1-.1-1.017l4.267-6.85a.832.832 0 0 1 .708-.391H15.5c.917 0 1.667.75 1.667 1.666ZM8.625 3.027 5.667 7.768a.835.835 0 0 1-1.309.134l-.775-.817c-.416-.417-.75-1.167-.75-1.667V3.502c0-1 .75-1.75 1.667-1.75h3.417c.65 0 1.05.716.708 1.275Z"
      fill="currentColor"
    />
  </svg>
));
